class RoleModel {
    public Id: string | null = null;
    public Name: string = "";
    public Description: string = "";
    public PermissionIds: string[] = [];
    public UserIds: string[] = [];
}

export { RoleModel };
